import { useEffect } from "react";
import { useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const InvitationDoctorSave = () => {
  const { id } = useParams();
  const { code } = useParams();
  const { hid } = useParams();
  const [registerData, setRegisterData] = useState({
    doctorEmailId: id,
    userFirstName: "",
    userLastName: "",
    privacyPolicy: true,
    thirdPartyInformationPolicy: true,
    password: "",
    hospitalId: hid,
  });

  const api = axios.create({
    baseURL: "https://dev-backend.rokithc.com",
    //baseURL: "http://localhost:8080",
  });

  const getMember = async (id) => {
    try {
      const response = await api.get(`/member/get_member?uid=${id}`);
      return response.data.data;
    } catch (e) {
      console.log(e);
    }
  };

  const saveDoctor = async (doctor) => {
    try {
      const formData = new FormData();
      formData.append("userFirstName", doctor.userFirstName);
      formData.append("userLastName", doctor.userLastName);
      formData.append("hospitalId", doctor.hospitalId);
      formData.append("doctorEmailId", doctor.doctorEmailId);
      formData.append("password", doctor.password);
      formData.append("privacyPolicy", doctor.privacyPolicy);
      formData.append(
        "thirdPartyInformationPolicy",
        doctor.thirdPartyInformationPolicy
      );

      return await api.post("/member/doctor-signup", formData);
    } catch (e) {
      alert("signup fail");
    }
  };

  useEffect(() => {
    console.log("Hospital Id > " + hid);
    getMember(id).then((res) => {
      if (res === null) {
        alert("error");
        window.close();
      } else {
        console.log("res.emailCertifiedCode > " + res.emailCertifiedCode);
        console.log("code > " + code);
        if (res.emailCertifiedCode !== code) {
          alert("Expired Certified Mail.");
          window.close();
        }
      }
    });
  }, []);

  const updateData = (e) => {
    console.log("Test > " + e.target.id + "/" + e.target.value);
    setRegisterData({
      ...registerData,
      [e.target.id]: e.target.value,
    });
  };

  const onKeyPress = (e) => {
    if (e.key == "Enter") {
      registerEnter();
    }
  };

  const registerEnter = () => {
    saveDoctor(registerData).then((res) => {
      if (res !== undefined && res !== null) {
        console.log("Register Success");
        alert("Register Success");
        window.close();
      } else {
        console.log("Register Fail");
        alert("Register Fail");
        window.close();
      }
    });
  };
  return (
    <div
      style={{
        width: "100%",
        height: "94vh",
        background:
          "linear-gradient(45deg, rgba(0,0,0,.5), transparent), linear-gradient(45deg, #43C6AC, #191654)",
        display: "flex",
        justifyContent: "çenter",
        alignItems: "center",
      }}
    >
      sender email : {id}
      <div style={{ margin: "auto" }} id="login" method="POST">
        <h3>Register</h3>
        <field>
          <label>First Name</label>
          <input
            type="text"
            id="userFirstName"
            placeholder="enter your first name..."
            value={registerData.userFirstName}
            onChange={updateData}
            onKeyPress={onKeyPress}
            required
          />
        </field>
        <field>
          <label>Last Name</label>
          <input
            type="text"
            id="userLastName"
            placeholder="enter your last name..."
            value={registerData.userLastName}
            onChange={updateData}
            onKeyPress={onKeyPress}
            required
          />
        </field>
        <field>
          <label>Password</label>
          <input
            id="password"
            type="password"
            placeholder="enter your password..."
            value={registerData.password}
            onChange={updateData}
            onKeyPress={onKeyPress}
            required
          />
        </field>
        <button id="submit" onClick={registerEnter}>
          Register
        </button>
      </div>
    </div>
  );
};

export default InvitationDoctorSave;
